import React, { useContext } from "react";
import { Link } from "react-router-dom";
import commonContext from "../../context/common";
import { leadType } from "../../../app";

function VehicleUpdateCard() {
    const lead = useContext(commonContext).lead as leadType;
    const { utils, base } = useContext(commonContext);
    return (
        <>
            <div className="details-blue-wrap vehicle-details w-full lighter-blue rounded-lg px-3 py-3 md:px-5 md:py-5 xl:px-8 xlpy-8">
                <p className="openSans-Reg text-black mb-2 md:mb-2 xl:mb-5 text-2xl md:text-2xl lg:text-3xl xl:text-4xl w-full">
                    Vehicle Details
                </p>
                <ul className="flex flex-wrap justify-between flex-col lg:flex-row">
                    <li className="mb-2 lg:mb-0">
                        <p className="openSans-SemiBold text-black text-lg md:text-lg lg:text-2xl xl:text-3xl">
                            {lead.manufacturer} {lead.make} {lead.model}
                        </p>
                        <p className="openSans-Reg grayshade-1 text-sm md:text-base lg:text-lg xl:text-lg">
                            {lead.dealerAddress}
                        </p>
                    </li>
                    <li className="mb-2 lg:mb-0">
                        <p className="openSans-Reg grayshade-1 text-sm md:text-base lg:text-lg xl:text-lg">
                            Total On-road Cost
                        </p>
                        <p className="openSans-SemiBold text-black text-lg md:text-lg lg:text-2xl xl:text-3xl">
                            <span className="WebRupee">Rs.</span>
                            {utils?.currencyFormat(lead.VDOnRoadCost)}
                        </p>
                    </li>
                    <li className="mb-0 lg:mb-0">
                        {base != "dd-al" && base != "qm-10-seconds" ? (
                            <Link
                                to="/vehicle-details"
                                className="openSans-Reg blue-text-1 no-underline hover:underline hover:text-black text-sm md:text-base lg:text-lg xl:text-lg transition-all inline-block pt-0 lg:pt-6"
                                title="Update"
                            >
                                Update
                            </Link>
                        ) : (
                            ""
                        )}
                    </li>
                </ul>
            </div>
        </>
    );
}

export default VehicleUpdateCard;
